import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/tickets/(ticket)/$ticketId/workspace/",
)({
	beforeLoad: ({ params }) => {
		throw redirect({
			to: "/web/$orgId/tickets/$ticketId/workspace/form",
			params: { orgId: params.orgId, ticketId: params.ticketId },
		});
	},
});
